import React from 'react';
import { NavLink } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import skimg from '../img/cropped-Simplify-second.png'
const Navbar = () => {
  return (
    <div className="container-fluid bg-white sticky-top p-4">
      <div className="container">
        <nav className="navbar navbar-expand-lg navbar-light p-0">
          <NavLink to="/" className="navbar-brand d-lg-none">
            <h1 className="fw-bold m-0">  <img className="custom-img" style={{ width: '50%', height: '100px', objectFit: 'contain' }} src={skimg} alt="Imagemy" /> </h1>
          </NavLink>
          <button
            type="button"
            className="navbar-toggler"
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse  fw-semibold" id="navbarCollapse">
            <div className="navbar-nav fs-5 gap-3" >
              <NavLink to="/" className="nav-item nav-link" activeClassName="active" >Home</NavLink>
              <NavLink to="/about" className="nav-item nav-link" activeClassName="active">About Us</NavLink>
           

              <div className="nav-item dropdown">
  <NavLink
    to="#"
    className="nav-link dropdown-toggle"
    data-bs-toggle="dropdown"
    style={{ color: '#665d5d' }} // Replace this with your desired color
  >
    Services
  </NavLink>
  <div className="dropdown-menu bg-light rounded-0 m-0">
    <NavLink to="/qualitative" className="dropdown-item">Qualitative Service</NavLink>
    <NavLink to="/quantitative" className="dropdown-item">Quantitative Service</NavLink>
    <NavLink to="/itservice" className="dropdown-item">IT Service</NavLink>
    <NavLink to="/onlineresearch" className="dropdown-item">Online Research</NavLink>
    <NavLink to="/businessresearch" className="dropdown-item">Business Research</NavLink>
    <NavLink to="/telephonesurvey" className="dropdown-item">Telephone Surveys</NavLink>
    
  </div>
</div>


              

              <div className="nav-item dropdown">
                <NavLink
                  to="#"
                  className="nav-link dropdown-toggle"
                  data-bs-toggle="dropdown"  style={{ color: '#746666' }}
                >
                  Download Reports
                </NavLink>
                <div className="dropdown-menu bg-light rounded-0 m-0">
                  <a 
                    href="https://drive.google.com/file/d/1a2YFxXtDUqhr2GJMdPv73qe81OWk6buK/view"                     
                    className="dropdown-item" 
                    target='_blank'
                    rel="noopener noreferrer">
                    CAPABILITIES PRESENTATION
                  </a>
                  <a 
                    href="https://drive.google.com/file/d/1mi4UMS8vi7Fs3QnUzsaYQg7XbSyp6HAc/view"                     
                    className="dropdown-item" 
                    target='_blank'
                    rel="noopener noreferrer">
                    CASE STUDIES 
                  </a>
                  <a 
                   href="https://drive.google.com/file/d/140UtpoLdIMS00fVZprxQB9m1EDYJFtiL/view"                     
                   className="dropdown-item" 
                   target='_blank'
                   rel="noopener noreferrer">
                    ESOMAR 28
                  </a>
                  <a 
                    href="https://drive.google.com/file/d/1y8UYzXX8IiNwI7RCaAJ1L2N9b-hjQS1t/view"                     
                    className="dropdown-item" 
                    target='_blank'
                    rel="noopener noreferrer">
                    GLOBAL PANEL BOOK
                  </a>                                  
        
                  <a 
                  href="https://drive.google.com/file/d/1HCIqvJNvZ345cmtwKw3_08UbIF44Hwsa/view"                     
                  className="dropdown-item" 
                  target='_blank'
                  rel="noopener noreferrer">
                   PIU & CIU Cases Study
                  </a>
                  <a 
                  href="https://drive.google.com/file/d/1OotoxH-c1Py0i39fJ0T3EE8d7vA4zvGM/view"                     
                  className="dropdown-item" 
                  target='_blank'
                  rel="noopener noreferrer">
                   PANEL QUALITY MEASURES
                  </a>
                </div>
              </div>

             
              <NavLink to="/joinourpanel" className="nav-item nav-link">Join Our Panel</NavLink>
              <NavLink to="/faq" className="nav-item nav-link">FAQ</NavLink>
              <NavLink to="/contact" className="nav-item nav-link">Contact Us</NavLink>

           
             

            </div>
           
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Navbar;
